export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ15.47705b23.mp3";